import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import { AppContextProvider } from "./context/AppContext";
import React, { useContext, Suspense } from "react";
import SignIn from "./pages/SignIn";
import PrivateRoute from "./components/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
import Loader from "./components/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Error from "./pages/Error";
import Profile from "./pages/Profile";
import ResetPassword from "./pages/ResetPassword";
import DeleteAccount from "./pages/DeleteAccount";
import ActiveSession from "./pages/ActiveSession";
import Dashboard from "./pages/Dashboard";
import UserManager from "./pages/UserManager";
import DocumentCategoryManager from "./pages/DocumentCategoryManager";
import LabManager from "./pages/LabManager";
import DoctorManager from "./pages/DoctorManager";
import ReportManager from "./pages/ReportManager";
import SubscriptionPriceManager from "./pages/SubscriptionPriceManager";
import ContentManager from "./pages/ContentManager";
import TransactionManager from "./pages/TransactionManager";
import EmailTemplateManager from "./pages/EmailTemplateManager";
import UserJourney from "./pages/UserJourney";
import CouponManager from "./pages/CouponManager";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsAndCondition";

window.Buffer = window.Buffer || require("buffer").Buffer;

function App() {
  return (
    <AuthProvider>
      <AppContextProvider>
        <Suspense fallback={<Loader />}>
          <BrowserRouter>
            <ScrollToTop />
            <ToastContainer closeOnClick={false} />
            <AppRoutes />
          </BrowserRouter>
        </Suspense>
      </AppContextProvider>
    </AuthProvider>
  );
}

const privateRoutes = (isLoggedIn) => {
  return (
    <Route
      path="/"
      element={
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      }
    >
      <Route index element={<Navigate to="/dashboard" replace />} />
      <Route exact path="/profile" element={<Profile />} />
      <Route exact path="/dashboard" element={<Dashboard />} />
      <Route exact path="/active-session" element={<ActiveSession />} />
      <Route exact path="/user-manager" element={<UserManager />} />
      <Route
        exact
        path="/document-category-manager"
        element={<DocumentCategoryManager />}
      />
      <Route exact path="/lab-manager" element={<LabManager />} />
      <Route exact path="/doctor-manager" element={<DoctorManager />} />
      <Route
        exact
        path="/transaction-manager"
        element={<TransactionManager />}
      />
      <Route exact path="/report-manager" element={<ReportManager />} />
      <Route exact path="/user-journey" element={<UserJourney />} />
      <Route
        exact
        path="/email-template-manager"
        element={<EmailTemplateManager />}
      />
      <Route exact path="/subscription-price-manager" element={<SubscriptionPriceManager />} />
      <Route exact path="/coupon-manager" element={<CouponManager />} />
      <Route exact path="/content-manager" element={<ContentManager />} />
    </Route>
  );


};

const publicRoutes = (isLoggedIn) => {
  return (
    <>
      <Route path="/login" element={<SignIn />} />
      <Route path="/" element={<SignIn />} />
      <Route path="/admin/reset-password/:id" element={<ResetPassword />} />
      <Route path="/user/delete" element={<DeleteAccount />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-and-conditions" element={<TermsConditions />} />
    </>
  );
};

const AppRoutes = () => {
  const { isLoggedIn } = useContext(AuthContext);

  return (
    <Routes>
      {!isLoggedIn && publicRoutes()}
      {isLoggedIn && privateRoutes()}
      <Route path="*" element={<Error />} />
    </Routes>
  );
};

const Layout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default App;
